// extracted by mini-css-extract-plugin
export default {"wrap":"List_wrap__EvMKD","operationArea":"List_operationArea__Iu93K"};